import TableTiptap from '@tiptap/extension-table';
import {
  mergeTableWithAbove,
  mergeTableWithBelow,
} from 'pages/revisions-module/template-editor/editors/template/extensions/table-merge';
import {
  splitTableAfterSelection,
  splitTableDown,
  splitTableUp,
} from 'pages/revisions-module/template-editor/editors/template/extensions/table-split';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    tableMerge: {
      mergeTableWithAbove: () => ReturnType;
      mergeTableWithBelow: () => ReturnType;
    };
    tableSplit: {
      splitTableUp: () => ReturnType;
      splitTableDown: () => ReturnType;
      splitTableAfterSelection: () => ReturnType;
    };
  }
}

export const Table = TableTiptap.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      'data-margin-top': { default: 0 },
      'data-margin-right': { default: 0 },
      'data-margin-bottom': { default: 16 },
      'data-margin-left': { default: 0 },
      style: {
        renderHTML(attributes) {
          const top = Number(attributes['data-margin-top'] ?? 0);
          const right = Number(attributes['data-margin-right'] ?? 0);
          const bottom = Number(attributes['data-margin-bottom'] ?? 16);
          const left = Number(attributes['data-margin-left'] ?? 0);
          return {
            style: `margin-top: ${top}px; margin-right: ${right}px; margin-bottom: ${bottom}px; margin-left: ${left}px;`,
          };
        },
      },
    };
  },

  addCommands() {
    return {
      ...this.parent?.(),
      mergeTableWithAbove:
        () =>
        ({ state, dispatch }) =>
          mergeTableWithAbove(state, dispatch),
      mergeTableWithBelow:
        () =>
        ({ state, dispatch }) =>
          mergeTableWithBelow(state, dispatch),
      splitTableUp:
        () =>
        ({ state, dispatch }) =>
          splitTableUp(state, dispatch),
      splitTableDown:
        () =>
        ({ state, dispatch }) =>
          splitTableDown(state, dispatch),
      splitTableAfterSelection:
        () =>
        ({ state, dispatch }) =>
          splitTableAfterSelection(state, dispatch),
    };
  },
});
